// import { Theme } from '@mui/material/styles'
declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    primary_gradient: true
    secondary: true
    primary: true
    cancel: true
    remove: true
  }
}
export const MuiButton = {
  // export default function Button(theme: Theme) {
  defaultProps: {
    // variant: 'contained',
    // color: 'secondary',
    // disableElevation: true,
  },
  variants: [
    {
      props: {
        variant: 'primary',
      },
      style: {
        backgroundColor: 'transparent',
        textTransform: 'none',
        fontWeight: 'bold',
        color: '#5e90f0',
        border: '1px solid #5e90f0',
        '&.Mui-disabled': {
          backgroundColor: 'grey',
          color: 'black',
        },
        '&:hover': {
          backgroundColor: '#ecf2fe',
          color: '#5e90f0',
        },
      },
    },
    {
      props: {
        variant: 'secondary',
      },
      style: {
        backgroundColor: '#5e90f0',
        color: 'white',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: '#4164a8',
          color: 'white',
        },
      },
    },
    {
      props: { variant: 'dashed' },
      style: {
        textTransform: 'none',
        border: `2px dashed blue}`,
      },
    },
    {
      props: { variant: 'dashed', color: 'secondary' },
      style: {
        border: `4px dashed red`,
      },
    },
    {
      props: { variant: 'cancel' },
      style: {
        textTransform: 'none',
        backgroundColor: '#aaaaaa',
        border: `2px dashed #aaaaaa`,
        'hover:': {
          backgroundColor: '#999999',
        },
      },
    },
    {
      props: { variant: 'remove' },
      style: {
        textTransform: 'none',
        backgroundColor: '#EFEFEF',
        'hover:': {
          backgroundColor: '#999999',
        },
        color: '#8A8A8A',
        fontWeight: '500',
        fontSize: '12px',
      },
    },
    {
      props: {
        variant: 'primary_gradient',
      },
      style: {
        backgroundColor: '#428BCA',
        backgroundImage: `linear-gradient(to bottom, #428BCA 0, #2d6ca2 100%)`,
        padding: '6px 12px',
        borderRadius: '4px',
        color: 'white',
        textTransform: 'none',
        ':hover': {
          background: '#2d6ca2',
        },
      },
    },
  ],
}
